import { useEffect, useState } from 'react';

export function useMediaQuery(query: string, defaultMatches = false) {
  const [matches, setMatches] = useState(defaultMatches);

  useEffect(() => {
    const listener = (e: MediaQueryListEvent) => {
      setMatches(e.matches);
    };
    const mql = window.matchMedia(query);
    mql.addEventListener('change', listener);
    setMatches(mql.matches);
    return () => {
      mql.removeEventListener('change', listener);
    };
  }, [query]);

  return matches;
}
